(function() {
  // eslint-disable-next-line max-len
  // https://stackoverflow.com/questions/68052027/in-htmx-how-do-i-request-a-specific-url-for-each-option-within-a-select-form-el
  // assumes <script src="https://unpkg.com/htmx.org@1.9.4"></script> has been added to the HTML/Matrix page
  document.body.addEventListener('htmx:configRequest', function(event) {
    let pathWithParameters = event.detail.path.replace(
      /:([A-Za-z0-9_]+)/g,
      function(_match, parameterName) {
        let parameterValue = event.detail.parameters[parameterName];
        delete event.detail.parameters[parameterName];
        return parameterValue;
      }
    );

    event.detail.path = pathWithParameters;
  });
})();
